import { OptionsRequestParams } from '@/library/components/form/inputs/select/types';

/**
 * `/lists` labels that can return the whole collection.
 * A trailing comment is the backend cap when `list()` applies one.
 * Only lists used by the current select-all work stay enabled.
 */
export const NON_PAGINATED_LISTS = new Set<string>([
  // 'account-base-types',
  // 'account-contract-early-termination-units',
  // 'account-contract-types',
  // 'account-groups',
  // 'account-setting-options',
  // 'account-types',
  // 'agent-types',
  // 'aggregation-types',
  // 'airlines',
  // 'airports', // limit 500
  // 'audit-evaluation-types',
  // 'benchmarks-system-tags',
  // 'budget-field-types', // limit 1000
  // 'budget-period-types',
  // 'budget-periods',
  // 'budget-types',
  // 'captain-report-enums',
  // 'captain-report-types',
  // 'captain-reports-templates',
  // 'charter-parties',
  // 'charter-party-broker-rate-units',
  // 'charter-party-broker-types',
  // 'charter-party-duration-types',
  // 'charter-party-evaluation-criteria',
  // 'charter-party-tc-hire-types',
  // 'charter-party-types',
  // 'chat-entity-types',
  // 'classification-societies',
  // 'commencement-of-laytime-events',
  // 'commencement-of-laytime-priorities',
  // 'company-types',
  // 'contact-types',
  // 'countries',
  // 'cp-forms',
  // 'crew-contracts',
  // 'crew-doc-types',
  // 'crew-document-categories',
  // 'crew-document-type-identifiers',
  // 'crew-evaluation-templates',
  // 'crew-license-grades',
  // 'crew-matrix-rule-types',
  // 'crew-medical-case-company-statuses',
  // 'crew-medical-case-ocimf-system-categorization',
  // 'crew-medical-case-pni-statuses',
  'crew-ranks', // limit 1000
  // 'crew-shift-types',
  // 'crew-shift-warning-types',
  'crew-statuses',
  // 'crew-training-statuses',
  // 'crew-wages',
  // 'criteria',
  // 'criteria-categories',
  // 'criteria-types',
  // 'cycle-strokes',
  // 'debit-credit',
  // 'deferral-calculation-methods',
  // 'deferral-frequencies',
  // 'delivery-processing',
  // 'delivery-report-statuses',
  // 'delivery-statuses',
  // 'department-roles',
  // 'departments',
  // 'drills',
  // 'email-message-types',
  // 'email-templates',
  // 'event-account-categories',
  // 'event-account-category-type',
  // 'event-audit-auditor-types',
  // 'event-audit-findings',
  // 'event-crew-medical-case-categories',
  // 'event-crew-medical-case-types',
  // 'event-finding-types',
  // 'event-importances',
  // 'event-medical-expenses',
  // 'event-modules',
  // 'event-progress',
  // 'event-statuses',
  // 'event-types',
  // 'existing-class-numbers', // limit 200
  // 'extension-and-dispensation-types',
  // 'finding-action-codes', // limit 1000
  // 'finding-categories', // limit 1000
  // 'finding-codes', // limit 1000
  // 'finding-preventive-corrective-action-fields', // limit 1000
  // 'finding-progress-statuses',
  // 'finding-sources',
  // 'finding-subcategories', // limit 1000
  // 'finding-types', // limit 1000
  // 'fleet-layer',
  // 'fleet-map-bottom-panel-view',
  // 'fleet-status',
  // 'form-field-rules',
  // 'form-field-types',
  // 'form-linked-entity-types',
  // 'form-obligation-setting-trigger-types',
  // 'form-progress',
  // 'form-reporting-tags',
  // 'form-statuses',
  // 'form-visibility',
  // 'forms', // limit 1000
  // 'forwarding-statuses',
  // 'freight-hire-collection-invoice-item-categories',
  // 'freight-hire-collection-item-categories',
  // 'freight-hire-collection-items',
  // 'fuel-grade-categories',
  // 'fuel-grades',
  // 'graph-intervals',
  // 'hold-ventilation-values',
  // 'importances',
  // 'intertanko-termination-reasons',
  // 'invoice-base-types',
  // 'invoice-company-types',
  // 'invoice-link-to-entity-types',
  // 'invoice-type-default-entities',
  // 'itinerary-types',
  // 'itinerary-vessels',
  // 'job-field-settings',
  // 'job-progress-statuses',
  // 'job-statuses',
  // 'job-template-types',
  // 'job-types',
  // 'laytime-events',
  // 'logging-service-actions',
  // 'lubricant-base-numbers',
  // 'lubricant-oil-state-engines',
  // 'lubricant-oil-states',
  // 'lubricant-types',
  // 'maintenance-job-types',
  // 'manning-agents',
  // 'manuals',
  // 'market-index-types',
  // 'mga-account-types',
  // 'mga-action-types',
  // 'mga-depletion-method',
  // 'mga-items-available',
  // 'mga-period-statuses',
  // 'misc-descriptions',
  'nationalities'
  // 'normal-balances',
  // 'onboard-filter-presets',
  // 'onboard-filter-types',
  // 'party-bank-accounts',
  // 'party-company-subtypes', // limit 1000
  // 'party-company-types', // limit 144
  // 'payment-terms',
  // 'performance-graphs',
  // 'period-units',
  // 'permission-restriction-levels',
  // 'person-ranks',
  // 'port-areas',
  // 'port-da-case-status',
  // 'port-da-items',
  // 'port-da-paid-by',
  // 'port-statement-action-types',
  // 'port-types',
  // 'purchasing-categories',
  // 'purchasing-categories-types',
  // 'purchasing-item-types',
  // 'purchasing-requisition-email-actions',
  // 'purchasing-requisition-item-filters',
  // 'purchasing-requisition-priorities',
  // 'purchasing-requisition-statuses',
  // 'purchasing-requisition-suppliers-states',
  // 'purchasing-requisition-templates', // limit 200
  // 'purchasing-requisitions', // limit 200
  // 'purchasing-table-settings',
  // 'purchasing-unit-types',
  // 'purchasing-units',
  // 'quicksuite-dashboards',
  // 'review-process-actions',
  // 'review-process-status',
  // 'risk-assessment-tables',
  // 'risk-categories',
  // 'root-cause-categories',
  // 'root-causes',
  // 'routing-areas', // limit 144
  // 'saved-items',
  // 'saved-tables',
  // 'scales',
  // 'schedule-intervals',
  // 'spare-parts-quality',
  // 'special-zones',
  // 'store-groups',
  // 'store-item-colors',
  // 'stores', // limit 200
  // 'supplier-delivery-spots',
  // 'tag-types',
  // 'termination-reasons',
  // 'ticketing-offer-statuses',
  // 'ticketing-statuses',
  // 'ticketing-types',
  // 'toolbar-tools',
  // 'trip-types',
  // 'two_factor_authentication_methods',
  // 'units',
  // 'vessel-ballast-tank-types',
  // 'vessel-consumption-types',
  // 'vessel-contact-info-types',
  // 'vessel-document-category-templates',
  // 'vessel-document-types',
  // 'vessel-fuel-tank-categories',
  // 'vessel-fuel-tank-types',
  // 'vessel-groups',
  // 'vessel-prefixes',
  // 'vessel-situations',
  // 'vessel-subtypes',
  // 'vessel-system-assignment-status',
  // 'vessel-system-assignments',
  // 'vessel-system-attribute-groups',
  // 'vessel-system-attribute-types',
  // 'vessel-system-group-types',
  // 'vessel-system-groups',
  // 'vessel-types',
  // 'vessels',
  // 'vessels-dwt-draft',
  // 'vetting-viq-chapters',
  // 'voyages', // limit 1000
  // 'wages-types',
  // 'widget-types',
]);

export const canSelectAllOptionsForListRequest = (
  request: OptionsRequestParams | undefined
): boolean => {
  const list = request?.params?.list;

  if (typeof list !== 'string') return false;

  return NON_PAGINATED_LISTS.has(list);
};
